import { useFullscreenPortal } from './chunk-MBTLYAMU.js';
import { cn } from './chunk-FFX3LZW7.js';
import * as React from 'react';
import * as PopoverPrimitive from '@radix-ui/react-popover';
import { jsx } from 'react/jsx-runtime';

var Popover = PopoverPrimitive.Root;
var PopoverTrigger = PopoverPrimitive.Trigger;
var PopoverAnchor = PopoverPrimitive.Anchor;
var PopoverContent = React.forwardRef(function PopoverContent2({ className, align = "center", sideOffset = 4, collisionPadding = 8, ...props }, ref) {
  const portalContainer = useFullscreenPortal();
  return /* @__PURE__ */ jsx(PopoverPrimitive.Portal, { container: portalContainer, children: /* @__PURE__ */ jsx(
    PopoverPrimitive.Content,
    {
      ref,
      align,
      sideOffset,
      collisionPadding,
      className: cn(
        "z-50 w-72 max-h-[var(--radix-popover-content-available-height)] overflow-y-auto overflow-x-hidden rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-hidden data-[state=open]:animate-in data-[state=closed]:animate-out",
        className
      ),
      ...props
    }
  ) });
});

export { Popover, PopoverAnchor, PopoverContent, PopoverTrigger };
//# sourceMappingURL=chunk-QOM4QXAM.js.map
//# sourceMappingURL=chunk-QOM4QXAM.js.map